export const games = [
  {
    id: 1,
    title: "CyberStrike 2077",
    category: "PC",
    keyType: "Global Steam Key",
    stock: "En Stock",
    bestPrice: 32.78,
    discountedFrom: 69.00,
    buyLink: "https://www.instant-gaming.com/fr/840-acheter-cyberpunk-2077-pc-jeu-gog-com/?igr=gamer-bc1658d",
    genre: ["FPS", "Action", "Cyberpunk"],
    languages: ["English", "French", "German"],
    platformIcons: ["win", "ps5", "xbox"],
    developer: { name: "NovaCore Studios", avatar: "/logox.png" },
    releaseDate: "2020",
    description: "Un FPS futuriste intense dans une mégalopole cyberpunk.",
longDescription: `Plongez dans les entrailles de 'Neon-Prime', une mégalopole où la frontière entre l'homme et la machine a disparu.
    
    CARACTÉRISTIQUES CLÉS :
    • Système de hacking temps réel : Piratez les implants de vos ennemis en plein combat.
    • Narration à choix multiples : Chaque décision influence le destin de la ville et vos alliances.
    • Verticalité totale : Explorez des grat-ciels immenses et des bas-fonds toxiques.`,
    images: ["/images/cyberpunk2077.jpg", "/images/cyber-2.png", "/images/cyber-3.jpeg", "/images/cyber-4.jpeg","/images/cyber-5.jpeg"],
    features: ["4K Ray-Tracing", "Audio 3D", "Feedback Haptique"],
    requirements: { min: "i5-9400 / GTX 1060 / 12GB RAM", reco: "i7-12700 / RTX 3080 / 16GB RAM", storage: "70 GB SSD" },
    video: "xa3me9e", // ID dailymotion
    isDailymotion: true,    // Plateforme dailymotion (Monétisé)
    reviews: [{ id: 1, author: "CyberGuy", rating: 5, comment: "L'ambiance est folle !" }],
    news: [{ id: 101, date: "12 Feb 2026", title: "Mise à jour 2.1 disponible", img: "/images/cyberpunk2077.jpg" }]
  },
  {
    id: 2,
    title: "The Legend of Zelda: Tears of the Kingdom",
    category: "Switch",
    keyType: "Nintendo Code",
    stock: "En Stock",
    bestPrice: 60.94,
    discountedFrom: 69.99,
    buyLink: "https://amzn.to/4cFNUbk",
    genre: ["Action", "Aventure", "Open World"],
    languages: ["French", "English", "Japanese"],
    platformIcons: ["switch"],
    developer: { name: "Nintendo", avatar: "/images/zelda-tears-of-the-kingdom.jpg" },
    releaseDate: "2023",
    description: "Une aventure épique dans le royaume d’Hyrule.",
longDescription: `L'aventure la plus vaste de l'histoire d'Hyrule. Utilisez les pouvoirs d'Emprise et de Fusion pour créer des véhicules et des armes uniques.
    
    DÉTAILS DE L'AVENTURE :
    • Trois mondes en un : Explorez les cieux, la surface d'Hyrule et les profondeurs mystérieuses.
    • Créativité sans limites : Le système de construction permet de résoudre les énigmes de mille façons différentes.
    • Épopée émotionnelle : Une quête poignante pour retrouver la princesse Zelda à travers le temps.`,
    images: ["/images/zelda-tears-of-the-kingdom.jpg", "/images/zelda-2.jpg", "/images/zelda-3.jpg", "/images/zelda-4.jpg"],   
     requirements: { min: "Nintendo Switch", reco: "Switch OLED", storage: "16 GB" },
    video: "xa2k0fo", // ID dailymotion
    isDailymotion: true,    // Plateforme dailymotion (Monétisé)
    reviews: [{ id: 2, author: "Hylian92", rating: 5, comment: "Le meilleur jeu de la Switch." }],
   news: [{ id: 103, date: "10 Jan 2024", title: "Record de ventes pour Zelda", img: "/images/zelda-tears-of-the-kingdom.jpg" }]
  },
  {
    id: 3,
    title: "Clair Obscur: Expedition 33",
    category: "PS5",
    keyType: "Steam Key",
    stock: "En Stock",
    bestPrice: 49.50,
    discountedFrom: 89.97,
    buyLink: "https://amzn.to/40VxWTd",
    genre: ["RPG", "Tour par tour"],
    languages: ["English", "French"],
    platformIcons: ["win", "ps5"],
    developer: { name: "Sandfall Interactive", avatar: "/logox.png" },
    releaseDate: "2025",
    description: "Un RPG mystérieux au style artistique unique.",
longDescription: `Un RPG au tour par tour révolutionnaire inspiré de la Belle Époque française. Menez l'expédition pour arrêter la Peintresse avant qu'elle ne peigne un nouveau nombre et n'efface l'humanité.
    
    POURQUOI Y JOUER :
    • Système de combat réactif : Parez et esquivez en temps réel même dans un système au tour par tour.
    • Direction artistique unique : Des paysages surréalistes dignes des plus grands musées.
    • Histoire poignante : Une course contre la montre où chaque membre de votre équipe sait que c'est son dernier voyage.`,
    images: ["/images/Expedition33.jpg", "/images/expedition-2.jpeg", "/images/expedition-3.jpeg", "/images/expedition-4.jpeg", "/images/expedition-5.jpeg"],
    requirements: { min: "Ryzen 5 / RTX 2060 / 16GB RAM", reco: "Ryzen 7 / RTX 3070 / 16GB RAM", storage: "50 GB" },
    video: "xa2k0fs", // ID dailymotion
    isDailymotion: true,    // Plateforme dailymotion (Monétisé)
    reviews: [],
    news: []
  },
  {
    id: 4,
    title: "Hogwarts Legacy",
    category: "Xbox One",
    keyType: "Steam Key",
    stock: "En Stock",
    bestPrice: 14.98,
    discountedFrom: 98.00,
    buyLink: " https://www.instant-gaming.com/fr/13386-acheter-hogwarts-legacy-l-heritage-de-poudlard-deluxe-edition-deluxe-edition-xbox-series-x-s-xbox-one-jeu-microsoft-store/?igr=gamer-bc1658d",
    genre: ["RPG", "Action", "Open World"],
    languages: ["French", "English", "German", "Spanish"],
    platformIcons: ["win", "ps5", "xbox"],
    developer: { name: "Avalanche Software", avatar: "/images/hogwarts-legacy.jpg" },
    releaseDate: "2023",
    description: "Vivez votre propre aventure dans l’univers Harry Potter.",
longDescription: `
      --- VIVEZ L'INATTENDU ---
      Hogwarts Legacy : L'Héritage de Poudlard est un RPG d'action-aventure en monde ouvert qui se déroule dans l'univers de Harry Potter au XIXe siècle. Pour la première fois, vous êtes au cœur de votre propre histoire.
      
      IMMERSION MAGIQUE :
      • Soyez l'élève que vous voulez : Choisissez votre maison (Gryffondor, Serpentard, Poufsouffle ou Serdaigle) et assistez aux cours de potions, de botanique et de défense contre les forces du mal.
      • Exploration au-delà du château : Envolez-vous sur votre balai ou sur un hippogriffe pour explorer le village de Pré-au-Lard, la Forêt Interdite et les régions environnantes.
      • Maîtrise de la magie : Apprenez des sorts puissants, améliorez vos compétences et combattez des mages noirs, des gobelins et des créatures fantastiques.
      
      Le jeu de rêve pour tout fan de la saga qui a toujours attendu sa lettre pour Poudlard.`,
    requirements: { min: "i5-6600 / GTX 960 / 16GB RAM", reco: "i7-8700 / RTX 1080 / 16GB RAM", storage: "85 GB" },
    images: ["/images/hogwarts-legacy.jpg", "/images/hogwarts-2.jpg", "/images/hogwarts-3.jpg", "/images/hogwarts-4.jpg", "/images/hogwarts-5.jpg"],
    video: "xa2k0fu", // ID dailymotion
    isDailymotion: true,    // Plateforme dailymotion (Monétisé)
    reviews: [{ id: 3, author: "PotterHead", rating: 4, comment: "Magique !" }],
 news: [{ id: 105, date: "20 Feb 2026", title: "Hogwarts Legacy 2 en préparation ?", img: "/images/hogwarts-legacy.jpg" }]
  },
  {
    id: 5,
    title: "Ghost of Yōtei",
    category: "PS5",
    keyType: "PSN Code",
    stock: "Bientôt",
    bestPrice: "69.00",
    discountedFrom: "69.00",
    buyLink: "https://amzn.to/4s63Nfp",
    genre: ["Action", "Aventure"],
    languages: ["Japanese", "English", "French"],
    platformIcons: ["ps5"],
    developer: { name: "Sucker Punch", avatar: "/images/Ghost-of-Yotei.jpg" },
    releaseDate: "2025",
    description: "Un jeu d’action inspiré du Japon féodal.",
longDescription: `En 1603, une nouvelle héroïne nommée Atsu traverse les terres sauvages entourant le mont Yōtei. Une histoire de vengeance et de liberté dans un Japon féodal sublime.
    
    CE QUI VOUS ATTEND :
    • Nouvelles armes : Maîtrisez le fusil à mèche et de nouveaux styles de combat au katana.
    • Nature sauvage : Un monde plus organique avec des interactions poussées avec la faune et la flore.
    • Graphismes PS5 Pro : Une gestion de la lumière et du vent qui dépasse tout ce qui a été fait auparavant.`,
    images: ["/images/Ghost-of-Yotei.jpg", "/images/yotei-2.jpg", "/images/yotei-3.jpg", "/images/yotei-4.jpg", "/images/yotei-5.jpg"],
   requirements: { min: "PS5 Console", reco: "PS5 Pro", storage: "90 GB" },
   video: "xa2k0fy", // ID dailymotion
    isDailymotion: true,    // Plateforme dailymotion (Monétisé)
    reviews: [],
    news: []
  },
  {
    id: 7,
    title: "GTA VI",
    category: "PS5, Xbox", // Affiche les deux sur la fiche
    keyType: "Xbox Key",
    stock: "Précommande",
    bestPrice: "?",
    discountedFrom: "?",
    genre: ["Action", "Open World"],
    languages: ["English", "French", "Spanish"],
    platformIcons: ["ps5", "xbox"],
    developer: { name: "Rockstar Games", avatar: "/logox.png" },
    releaseDate: "2026",
    description: "Le prochain open world révolutionnaire.",
longDescription: `
      --- BIENVENUE À LEONIDA ---
      Rockstar Games repousse les limites du possible avec GTA VI. Explorez l'État de Leonida, incluant les rues baignées de néons de Vice City et les zones sauvages des Grasslands. 
      
      RÉVOLUTIONS DU GAMEPLAY :
      • Duo Dynamique : Suivez l'histoire de Lucia et Jason dans un récit criminel inspiré de faits réels, avec une IA de partenaire ultra-réactive.
      • Écosystème Social Media : Un système In-Game de réseaux sociaux qui influence les missions et la réputation des personnages.
      • Physique de l'eau et météo : Des ouragans dynamiques et une gestion de l'eau jamais vue dans un monde ouvert.
      
      Le niveau d'interaction avec les PNJ et les intérieurs (plus de 70% des bâtiments sont visitables) redéfinit totalement l'immersion.`,
    images: ["/images/gta6.jpg", "/images/gta61.jpg", "/images/gta62.jpg", "/images/gta63.jpg", "/images/gta64.jpg", "/images/gta65.jpg"],
    requirements: { min: "TBA (Xbox Series X/S)", reco: "TBA (PS5 Pro)", storage: "200 GB" },
    video: "xa2k0fq", // ID dailymotion
    isDailymotion: true,    // Plateforme dailymotion (Monétisé)
    reviews: [],
    news: [
    { 
      id: 102, 
      date: "4 Dec 2024", 
      title: "Trailer officiel disponible", 
    image: "/images/blogs/gta6/gta6.jpg", 
      link: "/blogs/gta-6-trailer" 
    }
    ]
  },
  {
    id: 8,
    title: "Elden Ring",
    category: "PS5",
    keyType: "Steam Key",
    stock: "En Stock",
    bestPrice: 32.48,
    discountedFrom: 49.99,
    buyLink: "https://amzn.to/4sxoSzH",
    genre: ["RPG", "Action", "Souls-like"],
    languages: ["French", "English"],
    platformIcons: ["win", "ps5", "xbox"],
    developer: { name: "FromSoftware", avatar: "/logox.png" },
    releaseDate: "2022",
    description: "Levez-vous, Sans-éclat, et que la grâce guide vos pas.",
longDescription: `
      --- L'ENTRE-TERRE VOUS APPELLE ---
      Élu Jeu de l'Année, Elden Ring est l'aboutissement de la formule des "Souls" dans un monde ouvert d'une richesse inégalée. Co-écrit par George R.R. Martin, ce titre propose une mythologie profonde et sombre.
      
      POINTS CLÉS DU GAMEPLAY :
      • Liberté Totale : Explorez l'Entre-terre à votre rythme, découvrez des donjons cachés et des boss optionnels monumentaux.
      • Personnalisation : Des centaines d'armes, de sorts et de cendres de guerre pour créer un style de jeu unique (Guerrier, Mage, Samouraï...).
      • Extension Shadow of the Erdtree : Cette fiche inclut les détails de l'extension la plus ambitieuse de FromSoftware, ajoutant une toute nouvelle carte et des défis encore plus relevés.
      
      Un chef-d'œuvre de direction artistique où chaque panorama est un tableau.`,
    images: ["/images/eldenring.jpg", "/images/elden-boss.jpg", "/images/elden-landscape.jpg", "/images/elden-combat.jpg"],
    features: ["Open World Massif", "Multijoueur Coop/PvP", "Difficulté Légendaire"],
   requirements: { min: "i5-8400 / GTX 1060 / 12GB RAM", reco: "i7-8700K / RTX 3070 / 16GB RAM", storage: "60 GB" },
    video: "xa2kaca", // ID dailymotion
    isDailymotion: true,    // Plateforme dailymotion (Monétisé)
    reviews: [{ id: 4, author: "SoulsMaster", rating: 5, comment: "Le meilleur jeu de tous les temps." }],
news: [{ id: 104, date: "15 June 2025", title: "Shadow of the Erdtree : Le DLC ultime ?", img: "/images/eldenring.jpg" }] 
 },
 {
    id: 9,
    title: "Black Myth: Wukong",
    category: "PS5",
    keyType: "Steam Key",
    stock: "En Stock",
    bestPrice: 60.56,
    discountedFrom: 64.99,
    buyLink: "https://amzn.to/4bgm1Eh",
    genre: ["Action", "RPG", "Aventure"],
    languages: ["French", "English", "Chinese"],
    platformIcons: ["win", "ps5"],
    developer: { name: "Game Science", avatar: "/logox.png" },
    releaseDate: "2024",
    description: "Incarnez le Prédestiné dans ce RPG d'action inspiré de la mythologie chinoise.",
longDescription: `
      --- UNE ODYSSÉE MYTHOLOGIQUE ---
      Inspiré du roman classique 'La Pérégrination vers l'Ouest', ce titre redéfinit le genre Action-RPG. Vous incarnez le 'Prédestiné', explorant un monde sombre et magnifique peuplé de créatures issues du folklore chinois.
      
      DÉTAILS TECHNIQUES & GAMEPLAY :
      • Maîtrise du Bâton : Apprenez trois postures de combat (Piller, Thrust, Smash) pour vaincre plus de 80 boss uniques.
      • Transformations : Utilisez des sorts pour vous transformer en créatures ailées ou en guerriers massifs pour exploiter les faiblesses adverses.
      • Unreal Engine 5 : Des environnements photoréalistes, des forêts de bambous denses aux temples enneigés.
      
      Chaque boss possède son propre Lore, révélé à travers des cinématiques artistiques après chaque victoire.`,
    images: ["/images/wukong.jpg", "/images/wukong4.jpg", "/images/wukong3.jpg", "/images/wukong2.jpg", "/images/wukong1.jpg"],
    requirements: { min: "i5-8400 / GTX 1060 / 16GB RAM", reco: "i7-9700 / RTX 3060 / 16GB RAM", storage: "130 GB SSD" },
    video: "xa3me96", // ID dailymotion
    isDailymotion: true,    // Plateforme dailymotion (Monétisé)
    reviews: [],
    news: []
  },
  {
    id: 10,
    title: "Death Stranding 2: On the Beach",
    category: "PS5",
    keyType: "PSN Code",
    stock: "En Stock",
    bestPrice: 61.99,
    discountedFrom: 80.00,
    buyLink: "https://www.instant-gaming.com/fr/13292-acheter-death-stranding-2-on-the-beach-pc-steam/?igr=gamer-bc1658d",
    genre: ["Action", "Exploration"],
    languages: ["French", "English", "Japanese"],
    platformIcons: ["ps5"],
    developer: { name: "Kojima Productions", avatar: "/logox.png" },
    releaseDate: "2025",
    description: "Sam Porter Bridges revient pour un nouveau voyage épique.",
longDescription: `
      --- AU-DELÀ DE LA CONNEXION ---
      Hideo Kojima revient avec une suite qui promet de repousser les limites du jeu vidéo en tant qu'art. Sam Porter Bridges reprend son voyage pour sauver l'humanité de l'extinction dans un monde transformé.
      
      RÉVOLUTIONS VISUELLES ET NARRATIVES :
      • Un voyage intercontinental : Ne vous limitez plus aux UCA, explorez des environnements diversifiés allant de déserts arides à des zones inondées, tous magnifiés par le moteur Decima.
      • Évolution des connexions : Le système social "Strand System" revient avec de nouvelles façons d'interagir avec les structures des autres joueurs sans jamais les croiser.
      • Casting Cinématographique : Retrouvez Norman Reedus et Léa Seydoux dans une mise en scène digne des plus grands films de science-fiction.
      
      Plus qu'un jeu, une expérience sensorielle et philosophique unique au monde.`,
    images: ["/images/ds2.jpg", "/images/ds2A.jpg", "/images/ds2B.jpg", "/images/ds2C.jpg", "/images/ds2D.jpg", "/images/ds2E.jpg"],
    requirements: { min: "PS5 Console", reco: "PS5 Pro", storage: "100 GB" },
   video: "xa3me98", // ID dailymotion
    isDailymotion: true,    // Plateforme dailymotion (Monétisé)
    reviews: [],
    news: []
  },
  {
    id: 11,
    title: "The Witcher 4 (Polaris)",
    category: "PC",
    keyType: "GOG Key",
    stock: "bientôt",
    bestPrice: "?",
    discountedFrom: "?",
    genre: ["RPG", "Open World"],
    languages: ["French", "English", "Polish"],
    platformIcons: ["win", "ps5", "xbox"],
    developer: { name: "CD PROJEKT RED", avatar: "/logox.png" },
    releaseDate: "2026",
    description: "Le début d'une nouvelle saga pour la franchise culte The Witcher.",
longDescription: `
      --- UNE NOUVELLE SAGA COMMENCE ---
      Polaris est le nom de code du prochain grand RPG de CD PROJEKT RED, marquant le début d'une nouvelle trilogie dans l'univers de The Witcher. Adieu le REDengine, place à la puissance de l'Unreal Engine 5.
      
      CE QUE L'ON SAIT :
      • Une nouvelle école de Sorceleurs : Le teaser suggère l'apparition de "l'École du Lynx", ouvrant la porte à de nouveaux styles de combat et de signes magiques.
      • Monde Ouvert Nouvelle Génération : Profitez d'un niveau de détail et de réalisme inégalé, avec une narration environnementale encore plus poussée que dans Wild Hunt.
      • Choix et Conséquences : La marque de fabrique de la série revient avec des dilemmes moraux complexes qui influenceront le destin de régions entières.
      
      Le retour de la référence absolue du RPG de dark fantasy.`,
    images: ["/images/witcher4.jpg", "/images/witcher4A.jpg", "/images/witcher4B.jpg", "/images/witcher4C.jpg", "/images/witcher4D.jpg", "/images/witcher4E.jpg"],
   requirements: { min: "TBA", reco: "TBA", storage: "150 GB SSD" },
    video: "xa3me9c", // ID dailymotion
    isDailymotion: true,    // Plateforme dailymotion (Monétisé)
    reviews: [],
    news: []
  },
  {
    id: 12,
    title: "Marvel's Wolverine",
    category: "PS5",
    keyType: "PSN Code",
    stock: "Bientôt",
    bestPrice: "?",
    discountedFrom: "?",
    genre: ["Action"],
    languages: ["French", "English"],
    platformIcons: ["ps5"],
    developer: { name: "Insomniac Games", avatar: "/logox.png" },
    releaseDate: "2026",
    description: "Incarnez Logan dans une aventure brutale et viscérale.",
longDescription: `
      --- LA BRUTALITÉ À L'ÉTAT PUR ---
      Après le succès fulgurant de Spider-Man, Insomniac Games s'attaque à l'icône la plus sombre des X-Men : Logan. Préparez-vous pour un jeu d'action viscéral, violent et mature.
      
      CARACTÉRISTIQUES ATTENDUES :
      • Combat sanglant : Utilisez les griffes en adamantium pour des affrontements brutaux mettant à profit un système de démembrement et de régénération en temps réel.
      • Narration Sombre : Une histoire originale qui explore le passé tourmenté de Logan, loin des sentiers battus des films familiaux.
      • Exploration et Instinct : Utilisez les sens hyper-développés de Wolverine pour traquer vos ennemis et découvrir des secrets dans des environnements interactifs.
      
      Le jeu de super-héros le plus "Rated R" (mature) jamais produit par PlayStation.`,
    images: ["/images/wolverine.jpg", "/images/wolverine1.jpg", "/images/wolverine2.jpg", "/images/wolverine3.jpg", "/images/wolverine4.jpg"],
    requirements: { min: "PS5 Console", reco: "PS5 Pro", storage: "80 GB" },
    video: "xa3me9a", // ID dailymotion
    isDailymotion: true,    // Plateforme dailymotion (Monétisé)
    reviews: [],
    news: []
  },
  {
    id: 13,
    title: "Resident Evil 9",
    category: "XBOX Series X/S",
    keyType: "Steam Key",
    stock: "EN STOCK",
    bestPrice: 61.49,
    discountedFrom: 90.00,
    buyLink: "https://www.instant-gaming.com/fr/21512-acheter-resident-evil-requiem-deluxe-edition-xbox-series-x-s-microsoft-store/?igr=gamer-bc1658d",
    genre: ["Horreur", "Action"],
    languages: ["French", "English", "Japanese"],
    platformIcons: ["win", "ps5", "xbox"],
    developer: { name: "Capcom", avatar: "/logox.png" },
    releaseDate: "2026",
    description: "Le prochain chapitre terrifiant de la saga Resident Evil.",
longDescription: `L'horreur passe au monde ouvert. Explorez une ville côtière abandonnée où chaque maison peut cacher un cauchemar indicible.
    
    ÉVOLUTION DE LA SÉRIE :
    • Moteur RE Engine Next-Gen : Des visuels photoréalistes et des effets de décomposition terrifiants.
    • Survie tactique : Gérez vos ressources limitées dans un environnement vaste et imprévisible.
    • Conclusion épique : Le dénouement des fils narratifs entamés dans RE Village.`,
    images: ["/images/re9.jpg", "/images/re9-2.jpg", "/images/re9-3.jpg", "/images/re9-4.jpg", "/images/re9-5.jpg"],
    requirements: { min: "TBA", reco: "TBA", storage: "100 GB" },
    video: "xa3me94", // ID dailymotion
    isDailymotion: true,    // Plateforme dailymotion (Monétisé)
    reviews: [],
    news: []
  }
];